<div class="content">
  <div class="instruction-label">
    To properly estimate shipping charges, we need to know which state the products on this order will be shipped to.
  </div>
  <div class="instruction-label">
    Please select a state from the list below.
  </div>
  <div class="input-row">
    <mat-form-field class="select-field" subscriptSizing="dynamic">
      <mat-label>Ship to State</mat-label>
      <mat-select [(ngModel)]="selectedStateCode">
        @for (state of states(); track state) {
          <mat-option [value]="state.code">{{state.description}}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>
  <div class="button-row">
    <span class="spacer"></span>
    <button matButton="elevated" class="dialog-button warn-button" (click)="cancel()">
      Cancel
    </button>
    <button matButton="elevated" class="dialog-button primary-button" [disabled]="isBusy() || invalidSelection()"
      (click)="saveAndClose()">
      Save
    </button>
  </div>
</div>
